import * as React from 'react';
import * as edu from "./style.module.scss";
export const Edu = () => {
  return (
    <section className={edu.edu}>
      <div className="container">
        <div className={edu.wrap}>
          <div className={edu.text}>
            <p><strong>Для тех, кто ещё сомневается, учить английский с нами или нет, или не верит, что занятия на платформе могут быть действительно эффективными, мы подготовили видеообзор нашей платформы на примере курса «Английский для ваших целей». </strong></p>
            <p>В нём вы сможете не только рассмотреть структуру курса, но и пройти один из уроков уровня Elementary, увидеть, как разбирается грамматика и лексика, а главное, каким образом все эти знания выводятся в актив на наших уникальных тренажёрах, помогая вам заговорить на английском без ошибок.</p>
          </div>
          <div className={edu.vid}>
            <div className={edu.bg}>
              <iframe
                title={'Обзор платформы'}
                allow="autoplay; encrypted-media"
                src="https://65395.servicecdn.ru/videos/65395_ZueVwZZxFOCp9Sfp"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
